<script setup lang="ts">
  import omit from 'lodash-es/omit';
  import { computed } from 'vue';

  import useDialog from '../../composables/useDialog/useDialog';
  import CustomRender from '../CustomRender/CustomRender.vue';
  import Dialog from '../Dialog/Dialog.vue';

  const dialog = useDialog();

  const attributes = computed(() => {
    if (!dialog.active) return null;

    return omit(dialog.active, ['deferred', 'onConfirm', 'onCancel', 'slots']);
  });

  function onCancel() {
    if (dialog.active?.onCancel) {
      dialog.active.onCancel();
    }

    dialog.active?.deferred?.resolve({
      isCanceled: true,
    });

    dialog.close();
  }

  async function onConfirm() {
    if (dialog.active?.onConfirm) {
      await dialog.active.onConfirm();
    }

    dialog.active?.deferred?.resolve({
      isConfirmed: true,
    });

    dialog.close();
  }
</script>

<template>
  <Dialog :open="!!attributes" v-bind="attributes" @confirm="onConfirm" @cancel="onCancel">
    <template v-for="(value, name) in dialog.active?.slots" :key="name" #[name]>
      <CustomRender :render="value" />
    </template>
  </Dialog>
</template>
